module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/hall-list/plan-photowedding-lineup-kansai-1-a2cf464cf97a6342d29019a0f61a7c70.png";